import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'ke_saved_products';
const SNAPSHOT_KEY = 'ke_saved_product_snapshots';
const CHANGE_EVENT = 'ke:saved-change';

function readSaved() {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
  catch { return []; }
}

function readSnapshots() {
  try { return JSON.parse(localStorage.getItem(SNAPSHOT_KEY) || '[]'); }
  catch { return []; }
}

export function useSavedProducts() {
  const [savedIds, setSavedIds] = useState(readSaved);
  const [savedProducts, setSavedProducts] = useState(readSnapshots);

  useEffect(() => {
    const sync = () => { setSavedIds(readSaved()); setSavedProducts(readSnapshots()); };
    window.addEventListener('storage', sync);
    window.addEventListener(CHANGE_EVENT, sync);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener(CHANGE_EVENT, sync);
    };
  }, []);

  const toggleSaved = useCallback((productOrId) => {
    const productId = typeof productOrId === 'object' ? productOrId._id : productOrId;
    const current = readSaved();
    const removing = current.includes(productId);
    const next = removing ? current.filter((id) => id !== productId) : [...current, productId];
    const snapshots = readSnapshots().filter((product) => product._id !== productId);
    if (!removing && typeof productOrId === 'object') snapshots.push(productOrId);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    localStorage.setItem(SNAPSHOT_KEY, JSON.stringify(snapshots));
    window.dispatchEvent(new Event(CHANGE_EVENT));
    return next.includes(productId);
  }, []);

  const isSaved = useCallback((productId) => savedIds.includes(productId), [savedIds]);
  return { savedIds, savedProducts, savedCount: savedIds.length, isSaved, toggleSaved };
}
